import { Routes } from '@angular/router';

import { MaintenancePageComponent } from '@shared/components';
import { createLinkTokenMatcher } from '@shared/guards/link-token.matcher';
import { ValidUUIDGuard } from '@shared/guards/valid-uuid.guard';

/**
 * The paths the app owns outright. Kept as their own list so the branded-link matcher below
 * can reserve them from the route table itself: adding a route here is all it takes to keep
 * `/<that route>/<token-shaped segment>` from being mistaken for a branded link.
 */
const LITERAL_ROUTES: Routes = [
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
  },
  {
    path: 'linx',
    loadChildren: () => import('./modules/linx/modules/landing').then((m) => m.LANDING_PAGE_ROUTES),
  },
  {
    path: 'linx-request/:workflowId',
    loadChildren: () => import('./modules/linx/modules/linx-request').then((m) => m.LINX_REQUEST_ROUTES),
    canActivate: [ValidUUIDGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/linx-v1').then((m) => m.LINX_V1_ROUTES),
  },
  {
    path: '404',
    loadChildren: () => import('./modules/error').then((m) => m.PAGE_NOT_FOUND_ROUTE),
  },
];

const reservedSlugs = LITERAL_ROUTES.map((route) => (route.path ?? '').split('/')[0]);

export const APP_ROUTES: Routes = [
  ...LITERAL_ROUTES,
  // Branded customer links, last before the wildcard: the matcher only accepts token-shaped
  // URLs, and anything it turns down falls through to the redirect below.
  {
    matcher: createLinkTokenMatcher(reservedSlugs),
    loadComponent: () => import('./modules/link-entry').then((m) => m.LinkEntryComponent),
  },
  { path: '**', redirectTo: 'linx' },
];
